<script setup>
import {ref} from "vue"
import helpers from "@/lib/helpers";

const props = defineProps({
  parent: Object
})

const emits = defineEmits(['created', 'pending'])

const form = ref({message: null, amount: null, notes: null, reason: null})

const refund = async () => {
  if (!await helpers.confirm('Process refund now?'))
    return

  const t = await helpers.asyncAction(props.parent._links.self_url.href, 'POST', {data: form.value})
  console.log('t', t)
  if (t) {
    helpers.toast('Transaction refunded')
    emits('created', t)
  } else {
    helpers.toast('Transaction refunded processing, please check back for updates')
    emits('pending')
  }
}
</script>

<template>
  <div v-if="parent.available_amount_for_refund">
    <modal-portal to="bottom">
      <div class="text-right">
        <b-btn size="sm" variant="outline-primary" @click="refund" class="px-4">Refund</b-btn>
      </div>
    </modal-portal>
    <template v-if="!!parent.customer">
      <modal-row is-text label="Customer">
        {{ parent.customer.gli }} - {{ parent.customer.company }}
      </modal-row>
      <form-divider/>
    </template>

    <modal-row is-text label="Refund from Txn">
      <b>{{ parent.available_amount_for_refund | money }}</b> available to refund from {{ parent.gli }}
    </modal-row>

    <modal-row label="Message to Customer" v-if="['S','P','E'].includes(parent.type)">
      <b-input size="sm" v-model="form.message"/>
    </modal-row>

    <modal-row label="Reason" v-if="parent.type === 'E'">
      <b-select v-model="form.reason" size="sm" :options="
      [
          {value: 'BUYER_CANCEL', text: 'Buyer canceled'},
          {value: 'SELLER_CANCEL', text: 'Seller canceled'},
          {value: 'ITEM_NOT_RECEIVED', text: 'Buyer never received item'},
          {value: 'BUYER_RETURN', text: 'Buyer returned'},
          {value: 'ITEM_NOT_AS_DESCRIBED', text: 'Item not as described'},
          {value: 'OTHER_ADJUSTMENT', text: 'General adjustment'},
          {value: 'SHIPPING_DISCOUNT', text: 'Shipping discount'}]">
      </b-select>
    </modal-row>

    <form-divider/>

    <modal-row label="Internal Note" v-if="['B','P'].includes(parent.type)">
      <b-input size="sm" v-model="form.notes"/>
    </modal-row>

    <modal-row label="Amount">
      <b-input-group size="sm" prepend="-$">
        <form-currency size="sm" v-model="form.amount"/>
      </b-input-group>
    </modal-row>
  </div>

  <b-alert show v-else variant="danger">Transaction not refundable</b-alert>
</template>

<style scoped>

</style>